import React from 'react'
import {
  Card,
  AlertIndication,
  Title,
  DateDescription,
  VariantIcon,
  InformationContainer,
  BiRadsContainer
} from './styles'
import { transformDate } from '~/utils'
import { IconComponent } from '~/assets/icons/component'
import { HealthProcedureVariantProps } from '~/constants'
import { IHealthProcedures } from '~/interfaces'
import { IconName } from '~/assets/icons'
import { BiRadsBadge, TimelineTooltip } from '~/components/shared'

const HealthProcedureVariantIcon = ({ iconName, color }: { iconName: IconName; color: string }) => {
  return (
    <VariantIcon color={color} data-testid="variant-icon">
      <IconComponent name={iconName} />
    </VariantIcon>
  )
}

const ContentInformation = ({ title, date }: { title: string; date: string }) => {
  return (
    <InformationContainer>
      <Title>{title}</Title>
      <DateDescription>{transformDate({ date, withHourAndMinute: true })}</DateDescription>
    </InformationContainer>
  )
}

export interface CardHealthProcedureProps {
  healthProcedure: IHealthProcedures
  onClick: (healthProcedure: IHealthProcedures) => void
}

const CardHealthProcedure = ({ healthProcedure, onClick }: CardHealthProcedureProps): JSX.Element => {
  const { iconName, color: iconColor } = HealthProcedureVariantProps[healthProcedure.type]
  const { description: title, isAltered, startDate: date, biradsCategory } = healthProcedure

  return (
    <Card
      data-testid="cardHealthProcedure"
      title={title}
      color={iconColor}
      isAltered={isAltered}
      onClick={() => onClick(healthProcedure)}
    >
      <HealthProcedureVariantIcon iconName={iconName} color={iconColor} />

      <ContentInformation date={date} title={title} />
      <div className="arrow">
        <IconComponent name="chevronRight" />
      </div>

      {biradsCategory && (
        <BiRadsContainer>
          <BiRadsBadge category={biradsCategory} size="sm" />
        </BiRadsContainer>
      )}

      {isAltered && (
        <AlertIndication data-testid="altered-alert">
          <TimelineTooltip description={'Esse evento possui propriedades alteradas'}>
            <IconComponent name="circleExclamation" />
          </TimelineTooltip>
        </AlertIndication>
      )}
    </Card>
  )
}

export { CardHealthProcedure }
